import { UtilityService } from './index'

class CommunicationServices {

    async getAllInfo(){
        let result = await fetch(UtilityService.baseUrl() +'api/communication/getWindows',{
            method: "GET",
            headers:{
                'Accept':"application/json",
                "Content-Type":"application/json",
                "AuthToken":localStorage.getItem("authToken")
            }
            
        })
        return result.json();
    }

}
export default new CommunicationServices();


// WEBPACK FOOTER //
// ./src/services/communication.service.js